<template>
  <div class="bg-white rounded shadow overflow-x-auto">
    <table class="w-full whitespace-nowrap">
      <tr class="text-left font-bold">
        <th class="px-6 pt-6 pb-4">Name</th>
        <th class="px-6 pt-6 pb-4">Email</th>
        <th class="px-6 pt-6 pb-4">Mobile</th>
        <th class="px-6 pt-6 pb-4" colspan="2">Type</th>
      </tr>
      <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
        <td class="border-t">
          <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('users.edit', user.id)">
            <img v-if="user.photo" class="block w-5 h-5 rounded-full mr-2 -my-2" :src="user.photo">
            {{ user.name }}
            <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
          </inertia-link>
        </td>
        <td class="border-t">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
            {{ user.email }}
          </inertia-link>
        </td>
        <td class="border-t">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
            {{ user.mobile }}
          </inertia-link>
        </td>
        <td class="border-t">
          <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
            {{ user.customer ? 'Customer' : 'Staff' }}
          </inertia-link>
        </td>
        <td class="border-t w-px">
          <inertia-link class="px-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
            <Icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
          </inertia-link>
        </td>
      </tr>
      <tr v-if="users.length === 0">
        <td class="border-t px-6 py-4" colspan="4">No users found.</td>
      </tr>
    </table>
  </div>
</template>
<script>
import Icon from "@/Shared/Icon.vue";

export default {
  name: 'UsersTable',
  components: {Icon},

  props: {
    users: {
      type: Object,
      required: true
    }
  }
}
</script>
